import React from "react";
import { Link } from "react-router-dom";
import { FaUserTie } from "react-icons/fa";

const Frentes = () => {
  return (
    <div>
      <h1>Frentes</h1>
    </div>
  );
};

export default Frentes;
